export default __webpack_public_path__ + "static/peony-wax-63f1dd6d7f7a83e9b629ed2257444bc1.png";